import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { primaryColor } from '../../config/colors';

export const StyledLink = styled(Link)`
  font-weight: 600;
  text-decoration: none;
  color: ${({ isActive }) => (isActive ? primaryColor : 'black')};
`;
